module.exports = __webpack_public_path__ + "static/img/接诊模式@2x1.771d534a.png";